import { TreeView } from "@progress/kendo-react-treeview";

function CustomTreeBranch(props) {
    const pageTypeToIconMap = {
        "Entity Specific": <i className="p-0 far fa-square"></i>,
        "Entity Group": <i className="far fa-table" />,
        "Folder": <i className="p-0 fas fa-folder"></i>
    }

    function handleContextMenu(e) {
        props.handleContextMenu(e, props.item);
    };

    function getItemType() {
        return props.item.pageType || "Folder";
    }

    return (
        <span
            className="tree_branch"
            onClick={props.closeMenu}
            onContextMenu={
                props.item.type === "folder" ? null : handleContextMenu
            }
        >
            <span
                className={props.item.useAsReference ? "page-icon reference-page" : "page-icon"}
            >
                {pageTypeToIconMap[getItemType()]}
            </span>
            &nbsp;
            {props.item.text}
        </span>
    );
}

function PagesTreeView(treeViewProps) {
    return (
        <TreeView
            {...treeViewProps}
            item={(props) => (
                <CustomTreeBranch
                    item={props.item}
                    closeMenu={treeViewProps.onContextMenu}
                    handleContextMenu={treeViewProps.onContextMenu}
                />
            )}
        />
    )
}

export default PagesTreeView;